//created by sudip
import {
  ShieldCheck,
  Building2,
  BrainCircuit,
  Network,
} from "lucide-react";
import { Container } from "@/components/common/Container";
import {Section} from "@/components/common/Section";
import {SectionHeading} from "@/components/common/SectionHeading";

const values = [

  {

    icon: Building2,

    title: "Industry Expertise",

    description:
      "Solutions designed around real business operations rather than generic software workflows.",

  },

  {

    icon: ShieldCheck,

    title: "Compliance & Security",

    description:
      "Support for industry regulations, auditability and enterprise-grade security practices.",

  },

  {

    icon: Network,

    title: "Enterprise Integration",

    description:
      "Seamlessly connect existing ERP, CRM, HRMS, finance and operational systems.",

  },

  {

    icon: BrainCircuit,

    title: "AI Innovation",

    description:
      "Apply intelligent automation and AI insights to improve efficiency and decision-making.",

  },

];

export default function IndustryValueSection() {

  return (

    <Section spacing="compact" className="bg-muted/30">
      <Container>
        <SectionHeading
          eyebrow="Why VibeWell"
          title="Technology Alone Doesn't Solve Business Problems"
          description="Successful digital transformation combines modern technology with deep understanding of industry processes, compliance and organisational goals."
        />
        <div className="mt-10 grid gap-6 md:grid-cols-2 xl:grid-cols-4">

          {values.map((item) => {

            const Icon = item.icon;

            return (
              <div
                key={item.title}
                className="rounded-3xl border bg-background p-8 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10">
                  <Icon className="h-5 w-5 text-primary" />
                </div>
                <h3 className="mt-6 text-xl font-semibold">
                  {item.title}
                </h3>
                <p className="mt-4 leading-7 text-muted-foreground">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </Container>
    </Section>

  );

}